import React from 'react'
import Link from 'gatsby-link'
import Header from '../global/components/Header'


const ContentLayout = ({ children }) => (
  <div>

    <Header />

    <div className="wrapper--default-content">
      <div className="default--typography">
        { children() }
      </div>
    </div>

  </div>
)

export default ContentLayout



// WEBPACK FOOTER //
// ./src/layouts/content.js